// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import RightOutlinedSvg from "@ant-design/icons-svg/lib/asn/RightOutlined";
import AntdIcon from "../components/AntdIcon";
const RightOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: RightOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    RightOutlined.displayName = "RightOutlined";
}
export default /*#__PURE__*/ React.forwardRef(RightOutlined);
